import { __awaiter, __generator } from "tslib";
/**
 * Storage
 * Knows how how to store data by making use of a StorageAdapter
 */
var Storage = /** @class */ (function () {
    function Storage(config) {
        this.adapter = config.adapter;
        this.keyPrefix = config.keyPrefix || "";
    }
    Storage.prototype.get = function (key, defValue) {
        return this._get(this.decorateKey(key), defValue);
    };
    Storage.prototype.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, storableValues;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        return [4 /*yield*/, this.adapter.getAll()];
                    case 1:
                        storableValues = _a.sent();
                        Object.keys(storableValues).forEach(function (key) {
                            var decoratedKey = _this.decorateKey(key);
                            data[decoratedKey] = _this.isValid(storableValues[decoratedKey]) ? storableValues[decoratedKey].value : undefined;
                        });
                        return [2 /*return*/, Promise.resolve(data)];
                }
            });
        });
    };
    Storage.prototype.set = function (key, value, options) {
        return this._set(this.decorateKey(key), value, options);
    };
    Storage.prototype.has = function (key) {
        return this.adapter.has(this.decorateKey(key));
    };
    Storage.prototype.clear = function (key) {
        return this.adapter.clear(this.decorateKey(key));
    };
    Storage.prototype.clearAll = function () {
        return this.adapter.clearAll();
    };
    Storage.prototype.decorateKey = function (key) {
        return this.keyPrefix + key;
    };
    /**
     * isExpired
     * Knows how to check whether a IStorableValue is expired or not
     */
    Storage.prototype.isExpired = function (value) {
        var eTime = value.options.eTime;
        return !!eTime && new Date().getTime() >= eTime;
    };
    /**
     * _get
     * Knows how to obtain the value for the given property through the StorageAdapter.
     * It will take care of value expiration
     */
    Storage.prototype._get = function (decoratedKey, defValue) {
        return __awaiter(this, void 0, void 0, function () {
            var storableValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStorableValue(decoratedKey)];
                    case 1:
                        storableValue = _a.sent();
                        return [2 /*return*/, Promise.resolve(!storableValue ? defValue : storableValue.value)];
                }
            });
        });
    };
    /**
     * _set
     * Knows how to write the value for the given key through the
     * configured adapter to the storage.
     * It will also take care of value expiration when option is provided or when a value for this
     * key already exists in storage with the expire option.
     */
    Storage.prototype._set = function (decoratedKey, value, options) {
        return __awaiter(this, void 0, void 0, function () {
            var eTime, currentStorableValue, storableValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eTime = options && options.expire ? new Date().getTime() + options.expire : null;
                        return [4 /*yield*/, this.getStorableValue(decoratedKey)];
                    case 1:
                        currentStorableValue = _a.sent();
                        storableValue = {
                            options: {
                                eTime: eTime,
                            },
                            value: value,
                        };
                        if (currentStorableValue && currentStorableValue.options.eTime) {
                            storableValue.options.eTime = eTime;
                        }
                        return [2 /*return*/, this.adapter.set(decoratedKey, storableValue)];
                }
            });
        });
    };
    /**
     * getStorableValue
     * Knows how to obtain the IStorableValue through the StorageAdapter and
     * how to validate expire time.
     * When value is expired, null will be the result
     */
    Storage.prototype.getStorableValue = function (decoratedKey) {
        return __awaiter(this, void 0, void 0, function () {
            var storableValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adapter.get(decoratedKey)];
                    case 1:
                        storableValue = _a.sent();
                        if (!this.isValid(storableValue)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, storableValue];
                }
            });
        });
    };
    Storage.prototype.isValid = function (storableValue) {
        return storableValue && !this.isExpired(storableValue);
    };
    return Storage;
}());
export default Storage;
//# sourceMappingURL=Storage.js.map